import { reportReadinessFor, type ReportReadiness } from '../domain/reportReadiness';
import { formalEligibilityGateFor } from './formalWorkflow';
import { areasOf, inspectionStore, type InspectionState } from './inspectionStore';

// THE canonical answer to "is this inspection ready for the final client report?" (NY F1 Round 2,
// Owner correction OC-2), for every store action and every screen — the Report screen, the
// Closeout screen, the item sheet's field warning and generateFinalReportAction all read this one
// function and never restate the rule.
//
// It pairs the pure evaluator (src/domain/reportReadiness.ts) with the R1 ELIGIBILITY gate
// (src/state/formalWorkflow.ts) so the two gates stay separate and ordered: readiness only applies
// to an inspection the supported New York workflow applies to. An inspection that cannot be
// resolved is reported as NOT ready (fail-closed), never as ready. X-1 (the unsigned agreement) is
// deliberately NOT part of this question: the descriptors a report needs are the same whether or
// not the agreement has been signed yet, and the signature is gated elsewhere.
export function reportReadinessOf(inspectionId: string, state: InspectionState = inspectionStore.get()): ReportReadiness {
  const inspection = state.inspections.find((i) => i.id === inspectionId);
  if (!inspection) return { applies: true, ready: false, blockers: [], warnings: [] };
  const gate = formalEligibilityGateFor(inspection);
  return reportReadinessFor({
    inspection,
    areas: areasOf(state, inspectionId),
    items: state.items.filter((i) => i.inspectionId === inspectionId),
    formal: gate.kind === 'clear'
  });
}
